var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"rounded-full font-semibold",class:[
        _vm.meta.class,
        _vm.large ? 'px-3 py-1 text-sm' : 'px-2 py-0.5 text-xs'
    ]},[_vm._v(" "+_vm._s(_vm.meta.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }